import { render } from "./VendorsMasterView.vue?vue&type=template&id=6ba82f9c&scoped=true"
import script from "./VendorsMasterView.vue?vue&type=script&lang=js"
export * from "./VendorsMasterView.vue?vue&type=script&lang=js"

import "./VendorsMasterView.vue?vue&type=style&index=0&id=6ba82f9c&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba82f9c"]])

export default __exports__